import React, { memo } from 'react';
import cx from 'classnames';
import TabGalleryIcons from './TabGalleryIcons/TabGalleryIcons';
import TabMediaCount from './TabMediaCount/TabMediaCount';
import Button from '../Buttons/Button';

const Tab = memo(
  ({
    title,
    type,
    active,
    index,
    count,
    toggleTab,
    width,
    enabled,
    borderColor,
  }) => (
    <Button
      className={cx('tab', {
        active,
        gallery: type === 'tab-gallery',
      })}
      style={{
        width: width || '25%',
        ...(borderColor &&
          active && { borderBottom: `3px solid ${borderColor}` }),
        ...(!borderColor && active && { borderBottom: '3px solid #62789d' }),
      }}
      handleClick={() => toggleTab(index, enabled)}
      tabIndex={0}
      aria-label={title}
      data-cy={`tab-gallery-btn-${title}`}
      role="tab"
    >
      {type === 'tab-gallery' && <TabGalleryIcons tabTitle={title} />}
      <span className="tab-title">{title}</span>
      {type === 'tab-gallery' && <TabMediaCount count={count} />}
      {!enabled && <i className="material-icons">lock</i>}
    </Button>
  )
);

export default Tab;
